import { Component, Input } from '@angular/core';
import { PdfDocument } from '@shared/models/pdf-document';

@Component({
    standalone: false,
    selector: 'app-sgp-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent {

    @Input()
    pdfDocumentList: PdfDocument[] = [];

}
